import * as T from 'three';
import { C, mesh, ball, box, cyl, ring, link, tube, star, eyes, fur, scarf, boots, limbs, coat, belt, humanHead, gun, antler, candy } from './model-kit.js';

export const creatures = {
  'yeti'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
la.position.x=-.97;ra.position.x=.97;head.position.y=2.42;
      limbs(r,'#b4e5ed','#b4e5ed','#79bfd7');ball(body,'#c5edf1',0,1.4,0,1,.95,.64);ball(body,C.snow,0,1.52,.45,.7,.72,.3);
      for(const a of [la,ra]){ball(a,C.snow,0,-.05,0,.45,.39,.40);ball(a,'#8bcede',0,-.66,.03,.36,.32,.32);for(let i=0;i<3;i++)cyl(a,C.ice,(i-1)*.16,.20,-.10,.025,.13,.46,5);}
      ball(head,'#c5edf1',0,0,0,.6,.6,.48);ball(head,'#366a8a',0,-.03,.34,.44,.35,.2);eyes(head,.12,.48,.19,'#4ce5ff',true);
      box(head,C.dark,0,-.2,.5,.42,.16,.055);for(const s of [-1,1])cyl(head,C.white,s*.15,-.14,.55,0,.06,.17,8);
      for(let i=0;i<5;i++){const a=i/4*Math.PI;const spike=cyl(head,C.snow,Math.cos(a)*.43,.26+Math.sin(a)*.32,0,0,.18,.51,5);spike.rotation.z=-Math.cos(a)*.6;}
      link(body,'#638c9a',[-.67,1.93,.42],[.60,1.01,.51],.065);star(body,C.gold,0,1.4,.76,.16);
  },
  'polar-bear'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
la.position.x=-.85;ra.position.x=.85;limbs(r,C.snow,C.snow,'#d2e7e8');
      ball(body,C.snow,0,1.42,0,.89,.98,.64);ball(body,'#fffdf0',0,1.35,.45,.62,.74,.22);
      ball(head,C.snow,0,0,0,.59,.54,.49);for(const s of [-1,1]){ball(head,C.snow,s*.43,.42,-.02,.20);ball(head,'#aac6d0',s*.43,.43,.12,.10,.11,.05);}
      eyes(head,.12,.39,.22,C.dark,true);ball(head,'#fffcef',0,-.12,.46,.32,.22,.26);ball(head,C.dark,0,-.02,.68,.14,.10,.075);
      scarf(body,'#486791',2.03);for(const a of [la,ra]){cyl(a,'#486791',0,-.48,0,.25,.25,.18);box(a,C.ice,0,-.64,.21,.37,.30,.16,.3);}
      for(const l of [ll,rl])box(l,C.snow,0,-.48,.16,.51,.32,.68);
  },
  'narwhal'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
la.position.set(-.75,1.8,0);ra.position.set(.75,1.8,0);
      ball(body,'#70a5d2',0,1.40,0,.81,1.01,.64);ball(body,'#d7efea',0,1.27,.48,.59,.72,.25);
      ball(head,'#88b9dc',0,-.03,0,.61,.53,.49);eyes(head,.09,.43,.23,C.dark,true);ball(head,'#a9d4e0',0,-.18,.43,.29,.19,.16);
      const horn=cyl(head,'#fff0bf',0,.67,.14,0,.14,1.3,12,.25);horn.rotation.x=.15;
      for(let i=0;i<6;i++)ring(head,'#c8b786',0,.17+i*.13,.15,.12-i*.013,.014,.25).rotation.x=Math.PI/2;
      for(const [a,s]of [[la,-1],[ra,1]]){const fin=ball(a,'#5b8dbb',s*.11,-.25,0,.19,.53,.26);fin.rotation.z=s*.65;}
      for(const l of [ll,rl]){cyl(l,'#729cbf',0,-.12,0,.2,.18,.44);ball(l,'#497caa',0,-.47,.22,.26,.16,.45);}
      scarf(body,'#5c73a5',1.99);
  },
};
